require('./bootstrap');

// window.daterangepicker = require('bootstrap-daterangepicker');

// window.moment = require('moment');

require('icheck/icheck');

require('select2/dist/js/select2.full');
require('select2/dist/js/i18n/pt-BR');
